export default {
  bone: {
    height: '48px',
    borderRadius: '4px'
  },
  input: {
    '& .Select-multi-value-wrapper': {
      maxHeight: '300px',
      overflowY: 'auto'
    }
  }
}
